<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">
                  {{ item.tenantName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区选择">
              <a-tree-select :tree-data="zoneTreeData" v-model="query.zoneId" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择分区" allow-clear
                tree-default-expand-all></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编码">
              <a-input v-model="query.classNo" placeholder="请输入分类编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表编号">
              <a-input v-model="query.appearanceNo" placeholder="请输入水表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户用水类型">
              <a-select placeholder="请选择用户用水类型" default-value v-model="query.waterBigStatus">
                <a-select-option value>全部</a-select-option>
                <a-select-option :value="0">普通用户</a-select-option>
                <a-select-option :value="1">用水大户</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编码">
              <a-input v-model="query.userNo" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.userNikeName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>

              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ execlForm: true })"
                v-action:upload>下载模板</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()" :loading="exportLoading"
                v-action:export>导出</a-button>
              <a-button type="primary" style="margin-left: 8px" :loading="importLoading" @click="importHandle"
                v-action:import>
                <a-icon type="upload" />导入
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <a-tag color="blue" slot="status" slot-scope="text">{{ text ? 'yes' : 'NO' }}</a-tag>
      <template slot="waterBigStatus" slot-scope="text">
        <a-tag color="rgb(255, 99, 71)" v-if="text == 1">用水大户</a-tag>
        <a-tag color="#40a9ff" v-if="text == 0">普通用户</a-tag>
      </template>
      <!-- <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag> -->
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称" hasFeedback>
          <a-input
            :disabled="this.isUpdate"
            placeholder="片区名称"
            v-decorator="['zoneName']"
          />
        </a-form-item>-->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码" hasFeedback>
          <!-- :disabled="this.isUpdate" -->
          <a-input placeholder="分类编码" v-decorator="['classNo']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户编码" hasFeedback>
          <a-input :disabled="this.isUpdate" placeholder="用户编码"
            v-decorator="['userNo', { rules: [{ required: true, message: '请输入用户编码' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表编号" hasFeedback>
          <a-input :disabled="this.isUpdate" placeholder="水表编号"
            v-decorator="['appearanceNo', { rules: [{ required: true, message: '水表编号' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表状态" hasFeedback>
          <a-input placeholder="水表状态" v-decorator="['status', { rules: [{ required: true, message: '请输入水表状态' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户名称" hasFeedback>
          <a-input :disabled="this.isUpdate" placeholder="用户名称"
            v-decorator="['userNikeName', { rules: [{ required: true, message: '请输入用户名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户地址" hasFeedback>
          <a-input :disabled="this.isUpdate" placeholder="用户地址"
            v-decorator="['address', { rules: [{ required: true, message: '请输入用户地址' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号" hasFeedback>
          <a-input :disabled="this.isUpdate" placeholder="手机号"
            v-decorator="['phone', { rules: [{ required: true, message: '请输入手机号' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装时间">
          <a-date-picker placeholder="安装时间" :allowClear="false"
            v-decorator="['installDate', { rules: [{ required: true, message: '请选择埋设时间' }] }]" format="YYYY/MM/DD" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="口径" hasFeedback>
          <a-input placeholder="口径" v-decorator="['caliber', { rules: [{ required: true, message: '请输入口径' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌" hasFeedback>
          <a-input placeholder="品牌" v-decorator="['brand', { rules: [{ required: true, message: '请输入品牌' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型" hasFeedback>
          <a-input placeholder="类型" v-decorator="['type', { rules: [{ required: true, message: '请输入类型' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户用水类型">
          <a-select placeholder="请选择" default-value v-decorator="[
            'waterBigStatus',
            { rules: [{ required: true, message: '请选择用户用水类型' }], initialValue: 1 },
          ]">
            <a-select-option :value="0">普通用户</a-select-option>
            <a-select-option :value="1">用水大户</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
          <a-tree-select :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: false, message: '请选择片区' }] }]" style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
            tree-default-expand-all></a-tree-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <importModal ref="importModal" :tree-data="zoneTreeData" exportUrl="/pipe-network/gis_class_user_water_meters/import"
      @close="close"></importModal>
    <history-modal ref="historyModal"></history-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
// import HistoryModal from '../module/waterHistoryModal'
import importModal from '@/views/pipenetwork/module/ImportModal'

const STATUS = {
  1: '正常',
  2: '禁用'
}
const columns = [
  {
    title: '片区名称',
    dataIndex: 'zoneName'
  },
  {
    title: '用户编码',
    dataIndex: 'userNo'
  },
  {
    title: '分类编码',
    dataIndex: 'classNo'
  },
  {
    title: '水表编号',
    dataIndex: 'appearanceNo'
  },
  {
    title: '用户名称',
    dataIndex: 'userNikeName'
  },
  {
    title: '用户地址',
    dataIndex: 'address'
  },
  {
    title: '手机号',
    dataIndex: 'phone'
  },
  {
    title: '安装时间',
    dataIndex: 'installDate'
  },
  {
    title: '口径',
    dataIndex: 'caliber'
  },
  {
    title: '品牌',
    dataIndex: 'brand'
  },
  {
    title: '类型',
    dataIndex: 'type'
  },
  {
    title: '状态',
    dataIndex: 'status'
  },
  {
    title: '用户用水类型',
    dataIndex: 'waterBigStatus',
    scopedSlots: { customRender: 'waterBigStatus' }
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: {
    importModal
    // HistoryModal
  },
  mixins: [mixinViewModule],
  name: 'GisClassUserWaterMeter',
  data () {
    return {
      importLoading: false,
      downloadTemplateUrl: 'pipe-network/gis_class_user_water_meters/template/download', // 水表模板
      downloadTemplateName: '新分类编码用户水表导入模板.xlsx',
      fileList: [],
      exportDataUrl: 'pipe-network/gis_class_user_water_meters/export',
      exportFileName: '新分类编码用户水表.xlsx',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryUrl: 'pipe-network/gis_class_user_water_meters/page',
      addOrUpdateUrl: 'pipe-network/gis_class_user_water_meters',
      queryOneUrl: 'pipe-network/gis_class_user_water_meters',
      deleteUrl: 'pipe-network/gis_class_user_water_meters',
      downloadUrl: 'pipe-network/gis_class_user_water_meters/export',
      zoneTreeData: [], // 分区数据选项
      query: {
        zoneId: '',
        classNo: '',
        appearanceNo: '',
        userNo: '',
        userNikeName: '',
        tenantId: this.$store.state.user.info.tenantId,
        waterBigStatus: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.getZoneData()
    this.getAllTenant()
    this.resetList()
  },
  methods: {
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            ...values
          }
          console.log(typeof params.installDate)
          typeof params.installDate === 'string' ? '' : (params.installDate = params.installDate.format('YYYY/MM/DD'))
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    historyData () {
      this.$refs.historyModal.show()
    },
    // 关闭选择分区页面时
    close (val) {
      console.log(val)
      this.zoneId = val
      this.openSelectFile = true
    },
    importHandle () {
      console.log('导入按钮')
      this.$refs.importModal.show()
    },
    changeFile (info) { },
    customRequest (data) {
      // 上传提交
      console.log('123')
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('zone_id', this.zoneId)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/gis_class_user_water_meters/import',
        headers: {},
        params: {},
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
